import React from "react";
import {
  LandingSection,
  ProcessRail,
  SectionHeader,
} from "./landing/landing-ui";

const steps = [
  {
    title: "Discover",
    description:
      "Map the workflow, data sources, constraints, and success metrics with the people who own the work.",
  },
  {
    title: "Design",
    description:
      "Define architecture, tool access, evaluation criteria, and the human review points that keep risk contained.",
  },
  {
    title: "Pilot",
    description:
      "Ship a focused build against real data and real users. Measure outcomes before you scale spend.",
  },
  {
    title: "Operate",
    description:
      "Harden for production, document ownership, and hand off monitoring so your team can run the system.",
  },
];

function HowWeBuildAiSystems() {
  return (
    <LandingSection muted>
      <SectionHeader
        title="How engagements work"
        lead="A simple structure from first conversation to a system in production. No open-ended experiments without a path to ownership."
      />
      <ProcessRail steps={steps} />
    </LandingSection>
  );
}

export default HowWeBuildAiSystems;
